export default __webpack_public_path__ + "static/media/grandFather.22baffe0.svg";